import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Mail, Phone, MapPin } from 'lucide-react';
import { bundles } from '../data/products';

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark-900/90 backdrop-blur-md border-t border-primary-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <motion.div 
              className="flex items-center space-x-2 mb-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <img 
                src="https://tech4.stream/images/optimized/tech4-80x80.jpg" 
                alt="tech4.stream Logo" 
                className="w-8 h-8 rounded-lg"
              />
              <span className="text-xl font-bold gradient-text">tech4.stream</span>
            </motion.div>
            <p className="text-gray-300 mb-6 max-w-md">
              tech4.stream kuratiert die besten Streaming-Setups für Creator. 
              Von der Auswahl bis zum Setup - wir machen es einfach.
            </p>
          </div>

          {/* Produkte */}
          <div>
            <h3 className="text-white font-semibold mb-4">Produkte</h3>
            <ul className="space-y-2">
              {bundles.map(b => (
                <li key={b.id}>
                  <a href="#bundles" className="text-gray-300 hover:text-white transition-colors">{b.name}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="mt-8 pt-8 border-t border-gray-700">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-400">
            <div className="flex items-center">
              <Mail size={16} className="mr-2" />
              <span>olli@tech4.stream</span>
            </div>
            <div className="flex items-center">
              <Phone size={16} className="mr-2" />
              <a 
                href="https://wa.me/493093683026" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                +49 (0) 3093683026
              </a>
            </div>
            <div className="flex items-center">
              <MapPin size={16} className="mr-2" />
              <span>Deutschland</span>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-8 pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center">
          <div className="text-sm text-gray-400 mb-4 md:mb-0">
            © 2025 tech4.stream. Made with <Heart size={16} className="inline text-red-500" /> for Content Creators.
          </div>
          <div className="flex space-x-6 text-sm">
            <a href="/impressum" className="text-gray-400 hover:text-white transition-colors">Impressum</a>
            <a href="/datenschutz" className="text-gray-400 hover:text-white transition-colors">Datenschutz</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
